import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-header pb-2 d-flex align-items-center justify-content-between gap-2 flex-wrap" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 1,
  class: "flaticon-add me-1"
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted mb-0"
}
const _hoisted_9 = {
  key: 1,
  class: "receipts-grid"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "receipt-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, "Reçus de paiement (" + _toDisplayString(_ctx.receipts.length) + ")", 1),
      (_ctx.canUpload)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("input", {
              ref: "fileInput",
              type: "file",
              accept: "image/jpeg,image/png,image/webp",
              class: "d-none",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
            }, null, 544),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.uploading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileInput?.click()))
            }, [
              (_ctx.uploading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                : (_openBlock(), _createElementBlock("i", _hoisted_6)),
              _cache[2] || (_cache[2] = _createTextVNode(" Ajouter un reçu ", -1))
            ], 8, _hoisted_4)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.receipts.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Aucun reçu de paiement ajouté."))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receipts, (receipt) => {
              return (_openBlock(), _createElementBlock("a", {
                key: receipt.id,
                href: receipt.file,
                target: "_blank",
                rel: "noopener",
                class: "receipt-item"
              }, [
                _createElementVNode("img", {
                  src: receipt.file,
                  alt: "Reçu de paiement",
                  loading: "lazy",
                  referrerpolicy: "no-referrer"
                }, null, 8, _hoisted_11),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(receipt.created_at)), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(receipt.uploaded_by_name), 1)
                ])
              ], 8, _hoisted_10))
            }), 128))
          ]))
    ])
  ]))
}